/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ModernSecurityScheme } from '../../../core/models/common/ModernSecurityScheme';
import { OAuthFlows } from '../../../core/models/common/OAuthFlows';

/**
 * Constructor.
 * @param {string} schemeName
 * @class
 * @extends ModernSecurityScheme
 * @author eric.wittmann@gmail.com
 */
export class Oas30SecurityScheme extends ModernSecurityScheme {
    public constructor(schemeName : string) {
        super(schemeName);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.ModernSecurityScheme#createOAuthFlows()
     * @return {OAuthFlows}
     */
    public createOAuthFlows() : OAuthFlows {
        let rval : Oas30OAuthFlows = new Oas30OAuthFlows();
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }
}
Oas30SecurityScheme["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30SecurityScheme";
Oas30SecurityScheme["__interfaces"] = ["io.apicurio.datamodels.core.models.common.IDefinition","io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];





import { Oas30OAuthFlows } from './Oas30OAuthFlows';

